var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-charts"},[_c('v-chart',{ref:"bar",attrs:{"height":"254","forceFit":true,"options":_vm.options,"padding":['auto', 'auto', '40', '50']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }